fx.ns("desktop.print", class Main extends shared.BaseMain {

    constructor() {
        super(new repositories.PrintRepository(null, desktop.print.PrintEditorHistory));

        fx.set("app", "print");
    }

    init() {
        this.views = ["desktop.common.screens.Splash",
            "desktop.common.photoimport.GooglePanel",
            "desktop.common.photoimport.UploadProgress",
            "desktop.common.panels.SelectPhotosPanel",
            "shared.screens.PrintBoxChoices",
            //"shared.screens.PrintSizeChoices",
            "shared.screens.UpsellFirstScreen",
            "shared.screens.UpsellSecondScreen",
            "desktop.print.CheckPrintPanel",
            "desktop.print.PrintEditor",
            "desktop.print.PrintPhotoChoices",
            "shared.screens.Saving"
        ];

        fx.enableToolTip();
        this.on("TAB-DOWN", this._toggleGridMode, fx.keyboard);

        this.on("photo-extracted", this._onPhotoExtracted, fx.service("MediasUploader"));
        this.on("photo-extracted-started", this._onPhotoExtractedStarted, fx.service("MediasUploader"));
        this.on("photo-extracted-finished", this._onPhotoExtractedFinished, fx.service("MediasUploader"));
        
        // prints are made on validation (_importPhotos) : hence no photo-extracted* on GoogleService
    }

    _onPhotoExtractedStarted() {
        this.popup(new shared.popups.ExtractingPhotosPopup());
    }

    _onPhotoExtracted(e) {
        if (this.model.print.canAdd)
            this.model.addPrint(e.detail);
        else
            this.model.event("max-number-prints", 500);
    }

    _onPhotoExtractedFinished(e) {
        // fires on every upload tick : must not wipe a pending exit/order via
        // show-editor during the post-login reaffect (clears actionRequested)
        if (this.actionRequested) return;
        this.model.event("show-editor");
    }



    onDataEvent(e) {
        super.onDataEvent(e);

        switch (e.type) {
            case "start":
                if (this.model.creationid) {
                    if (this.previewMode)
                        this.steps({ view: "Splash", skipPrevious: true }, { view: "CheckPrintPanel", skipPrevious: true }, "UpsellFirstScreen"); // ajouter editeur
                    else
                        this.steps({ view: "Splash", skipPrevious: true }, "PrintEditor");
                }
                else {
                    fx.set("mode", "creating");

                    let steps = [];

                    /*if (this.model.creationProductOption.editor_code.startsWith("scrapbooking"))
                        steps.push({ view: "PrintSizeChoices", skipPrevious: true });
                    else*/
                    if (this.model.creationProductOption.editor_code.startsWith("box-"))
                        steps.push({ view: "PrintBoxChoices", skipPrevious: true });

                    steps.push({ view: "Splash", skipPrevious: true });

                    steps.push("PrintPhotoChoices");
                    steps.push("PrintEditor");

                    this.steps(steps);
                }
                break;

            case "creation-loaded":
                this._removeLostPhotoPrints();
                break;

            case "import-pictures-panel":
                this.popup(new desktop.common.photosimport.ImportPicturesPanel(this.model, e.detail));
                break;

            case "edit-photo":
                this.switchTo("EditPhoto", { photo: e.data, model: this.model });
                break;

            case "edit-text":
                this.switchTo("EditText", { text: e.data, model: this.model });
                break;

            case "upload-progress":

                this.popup(new desktop.common.photoimport.UploadProgress(this.model));
                break;

            case "upload-finished":
                if (this.actionRequested)
                    this.model.event(this.actionRequested, 250);  // we add a delay to let time for updates
                break;

            case "import-google":
                this.popup(new desktop.common.photoimport.GooglePanel(this.model));
                break;

            case "order":
                // ordering is a commitment : adding prints is no undoable update, so the
                // creation would stay deleted and the night cleaning would take its photos
                this.model.undelete();

                let steps = [];
                steps.push({ view: "CheckPrintPanel", skipPrevious: true });

                if (!this.model.creation.isScrapBooking)
                    steps.push("UpsellFirstScreen");

                this.steps(steps);
                break;

            case "no-upsell-available":
                if (this.readyLeaving(e.type))
                    this.model.event("navigate-order");
                break;

            case "upsell-selected":
                if (this.readyLeaving(e.type))
                    this.model.event("navigate-order");
                break;

            /*case "close-upsell":
                if (!this.optionsMode)
                    this.model.event("show-editor");
                else
                    this.model.event("previous-step");
                break;*/


            case "exit-editor":
                if (this.readyLeaving(e.type))
                    this.model.event("navigate-exit");
                break;

            case "selectphotos":
                this.switchTo("PrintPhotoChoices", {model : this.model, component : e.detail});
                break;

            case "step-PhotoAnalyse":
            case "show-editor":
                this.actionRequested = ""
                this.switchTo("PrintEditor");
                break;

            case "screen-saving":
                this.switchTo("Saving");
                break;
            
            // both the creation wizard and standard editing use the shared SelectPhotosPanel flow.
            // The prints are created on validation (_importPhotos), so "Quitter" leaves nothing
            // behind and the shared "still receiving : import anyway ?" confirmation is kept.
            case "import-mobile":
                this._startMobileImport();
                break;

            case "mobile-upload-send":
            case "mobile-upload-started":
                this._showMobileImport();
                break;

            // validated : the prints are made above, open the editor
            case "google-photos-added":
                this.model.event("show-editor");
                break;
        }
    }

    _removeLostPhotoPrints() {
        let lost = this.model.removeLostPhotoPrints();
        if (lost > 0)
            this.popup(new shared.popups.LostPhotosPrints(this.model, lost));
    }

    // Importer (or a confirmed early import) : the prints are made here, not as the photos arrive
    _importPhotos() {
        let source = this.importSource;

        if (source)
        {
            let received = source.receivedPhotos;
            for (let i = 0; i < received.length; i++)
            {
                if (!this.model.print.canAdd)
                {
                    this.model.event("max-number-prints", 500);
                    break;
                }
                this.model.addPrint(received.getItemAt(i));
            }
        }

        super._importPhotos();
    }

    _toggleGridMode(e) {
        fx.get("settings").toggleGridMode();

        e.stopPropagation();
        e.preventDefault();
    }

});